import { useCookies } from 'react-cookie';

const backendBasePath = process.env.NEXT_PUBLIC_DEV_BACKEND_URL;

export const useRefreshCompanyCache = () => {
  const [cookies] = useCookies(['expiry', 'access-token', 'client', 'uid', 'user-type']);

  const refreshCompanyCache = async (companyId: string): Promise<{ success: boolean }> => {
    const url = `${backendBasePath}/admin/companies/${companyId}/refresh_cache`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          uid: cookies['uid'],
          client: cookies['client'],
          'access-token': cookies['access-token'],
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        return { success: false };
      }

      const result = await response.json();
      return result;
    } catch (error) {
      throw error;
    }
  };

  return {
    refreshCompanyCache,
  };
};
